import { SummaryBox } from "@/components/ui/SummaryBox";
import { colors, Stack } from "@mui/material";

type Props = {
  summary: {
    accepted: number;
    rejected: number;
  };
};

export function AssetsForSubmissionSummary({ summary }: Props) {
  const { accepted, rejected } = summary;

  return (
    <Stack
      gap={0.5}
      direction={"row"}
      sx={{ verticalAlign: "middle", display: "inline-flex" }}
    >
      <SummaryBox
        count={accepted}
        sx={[
          {
            color: colors.green[800],
            backgroundColor: colors.green[50],
          },
          (theme) =>
            theme.applyStyles("dark", {
              backgroundColor: "background.paper",
              color: colors.green[300],
            }),
        ]}
      />
      <SummaryBox
        count={rejected}
        sx={[
          {
            color: colors.red[800],
            backgroundColor: colors.red[50],
          },
          (theme) =>
            theme.applyStyles("dark", {
              backgroundColor: "background.paper",
              color: colors.red[300],
            }),
        ]}
      />
    </Stack>
  );
}
